module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/chat-5-53456a2f1e23a2cbcee1fa7ed495cfe9.svg";